import { SalesChannel } from '../dto/model';

/** Special sales channels in display order (pair with getSalesChannelLabel for UI text). */
export const specialSalesChannels: readonly SalesChannel[] = [
  SalesChannel.SpecialSalesChannel1,
  SalesChannel.SpecialSalesChannel2,
  SalesChannel.SpecialSalesChannel3,
  SalesChannel.SpecialSalesChannel4,
  SalesChannel.SpecialSalesChannel5,
];

/** Inbound header dropdown order (shared with menu construction). */
export const HEADER_SALES_CHANNEL_MENU_ORDER: readonly SalesChannel[] = [
  SalesChannel.DigitalSales,
  SalesChannel.CrmSales,
  SalesChannel.FieldSales,
  SalesChannel.Revision,
  SalesChannel.LeadQueue,
  ...specialSalesChannels,
];

/** Ant Design <Tag> colors for reactivated-customer badge by sales channel. */
export const REACTIVATED_CUSTOMER_TAG_COLOR: Partial<Record<SalesChannel, string>> = {
  [SalesChannel.CrmSales]: 'blue',
  [SalesChannel.SpecialSalesChannel1]: 'cyan',
  [SalesChannel.SpecialSalesChannel2]: 'geekblue',
  [SalesChannel.SpecialSalesChannel3]: 'purple',
  [SalesChannel.SpecialSalesChannel4]: 'magenta',
  [SalesChannel.SpecialSalesChannel5]: 'volcano',
};
